/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        // Sticky
        $(".header__nav").sticky({ zIndex: 9999 });
        $(window).resize(function () {
          $(".header__nav").sticky("update");
        });

        //Slick
        $(".page__carousel").slick({
          arrows: true,
          autoplay: true,
          fade: true,
          prevArrow:
            "<button type='button' class='slick-arrow slick-prev'><i class='fal fa-angle-left' aria-hidden='true'></i></button>",
          nextArrow:
            "<button type='button' class='slick-arrow slick-next'><i class='fal fa-angle-right' aria-hidden='true'></i></button>",
          slidesToScroll: 1,
          slidesToShow: 1,
          speed: 3000,
        });

        //AOS
        AOS.init({
          disable: function () {
            var maxWidth = 800;
            return window.innerWidth < maxWidth;
          },
          once: true,
        });

        // Hamburger
        var $hamburger = $(".hamburger");

        $hamburger.on("click", function (e) {
          $hamburger.toggleClass("is-active");
          $(".la-reunion__menu").toggleClass("la-reunion__menu-active");
          $("body").toggleClass("modal-open");
        });
      },
    },
    // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        $(document).ready(function () {
          var inst = $("[data-remodal-id=modal]").remodal();
          inst.open(); // open modal on page load
        });
      },
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function () {
        // JavaScript to be fired on the about us page
      },
    },
    // Policies
    page_template_template_policies: {
      init: function () {
        (function (w, d) {
          var loader = function () {
            var s = d.createElement("script"),
              tag = d.getElementsByTagName("script")[0];
            s.src = "https://cdn.iubenda.com/iubenda.js";
            tag.parentNode.insertBefore(s, tag);
          };
          if (w.addEventListener) {
            w.addEventListener("load", loader, false);
          } else if (w.attachEvent) {
            w.attachEvent("onload", loader);
          } else {
            w.onload = loader;
          }
        })(window, document);
      },
      finalize: function () {},
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        }
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
